/*global require: false */
require(['jquery',
    'validate',
    'unobtrusive',
    'validateAll',
    'mvcFoolProofValidate'],

    function ($) {
        'use strict';

        $('#AccountNumberLinks').change(function () {
            if ($('#AccountNumberLinks').val() == 'Provider Tax Identification Number (TIN)') {
                $('#dupTIN').removeClass('hide');
                $('#dupNPI').addClass('hide');
                $('#DupeNationalProviderIdentifier').val(null);
                $('#DupeIdentificationNumber').val(null);
            }
            else {
                if ($('#AccountNumberLinks').val() == 'National Provider Identification Number (NPI)') {
                    $('#dupTIN').addClass('hide');
                    $("#dupNPI").removeClass('hide');
                    $('#DupeNationalProviderIdentifier').val(null);
                    $('#DupeIdentificationNumber').val(null);
                }
            }
        });

        $('#SelectedRetrievalMethod').change(function () {
            if ($('#SelectedRetrievalMethod').val() == 'Clearinghouse') {
                $('#dupClsh').removeClass('hide');
                $('#dupVndr').addClass('hide');
                $('#DupeVendor').val(null);
                $('#DupeVendorContactName').val(null);
            }
            else {
                if ($('#SelectedRetrievalMethod').val() == 'Vendor') {
                    $('#dupVndr').removeClass('hide');
                    $('#dupClsh').addClass('hide');
                    $('#DupeClearinghouse').val(null);
                }
                else {
                    $('#dupVndr').addClass('hide');
                    $('#dupClsh').addClass('hide');
                    $('#DupeClearinghouse').val(null);
                    $('#DupeVendor').val(null);
                    $('#DupeVendorContactName').val(null);
                }
            }
        });

    });
define("era-form", function(){});

